// Folds the letters NFD can't strip the way Postgres `unaccent` does, so filtering in the browser matches the backend search.
const UNDECOMPOSABLE_LETTERS: Record<string, string> = {
    æ: "ae",
    ð: "d",
    đ: "d",
    ħ: "h",
    ı: "i",
    ĸ: "q",
    ŀ: "l",
    ł: "l",
    ŋ: "n",
    ø: "o",
    œ: "oe",
    ß: "ss",
    þ: "th",
    ŧ: "t"
};

const UNDECOMPOSABLE_LETTERS_REGEX = new RegExp(`[${Object.keys(UNDECOMPOSABLE_LETTERS).join("")}]`, "g");

export function normalizeSearchText(value: string) {
    return value
        .trim()
        .normalize("NFD")
        .replace(/\p{M}/gu, "")
        .toLowerCase()
        .replace(UNDECOMPOSABLE_LETTERS_REGEX, letter => UNDECOMPOSABLE_LETTERS[letter] ?? letter);
}
